import { DuetDatePicker } from "@duetds/date-picker/custom-element";

export default function SearchBarCalender(
    moment,
    houseService,
    searchBarFactory
) {
    return {
        restrict: "E",
        //require : '^searchBar',
        template: require("./template.html"),

        controller: function ($scope) {
            $scope.$watch(
                "oSearchCalender.activeDropdown",
                function (isActive) {
                    if (isActive == true) {
                        openCalender();
                    } else {
                        // closeCalender();
                    }
                }
            );
            // const closeCalender = () => {
            //     console.log("close");
            // };
            const openCalender = () => {
                if (customElements.get("duet-date-picker") === undefined) {
                    customElements.define("duet-date-picker", DuetDatePicker);
                }

                customElements.whenDefined("duet-date-picker").then(() => {
                    // Select the date picker component
                    const today = new Date();
                    const picker = document.querySelector("duet-date-picker");

                    picker.disabled = true;

                    const momentLocaleData = moment.localeData();
                    //picker.value = moment(obj.date, "DD-MM-YYYY").format("YYYY-MM-DD");

                    // console.log(picker);
                    picker.localization = {
                        buttonLabel: "buttonLabel",
                        placeholder: "Dato",
                        selectedDateMessage: "Valgt dato",
                        prevMonthLabel: "Forrige måned",
                        nextMonthLabel: "Næste måned",
                        monthSelectLabel: "Vælg måned",
                        yearSelectLabel: "Vælg år",
                        closeLabel: "Luk",
                        calendarHeading: "Vælg dato",
                        dayNames: momentLocaleData._weekdays,
                        monthNames: momentLocaleData._months,
                        monthNamesShort: momentLocaleData._monthsShort,
                        locale: "da-DK",
                    };

                    // Listen for when date is selected
                    picker.addEventListener(
                        "duetChange",
                        function (e) {
                            const dateFormatForService = moment(
                                e.detail.valueAsDate,
                                "YYYY-MM-DD"
                            ).format("DD-MM-YYYY");

                            searchBarFactory.updateCalender(
                                dateFormatForService,
                                false
                            );

                            searchBarFactory.setFocusOnSubmitButton();
                        },
                        { once: true }
                    );

                    picker.addEventListener(
                        "duetOpen",
                        function (e) {
                            console.log("duet open calender", e);

                            setPickerValue($scope.calenderFilter.selectedDate);
                        },
                        { once: true }
                    );

                    picker.addEventListener("duetClose", duetClose);

                    picker.addEventListener(
                        "duetFocus",
                        function (e) {
                            console.log("duet focus input", e);

                            // searchBarFactory.activateDropdown(
                            //     $scope.oSearchCalender
                            // );
                        },
                        { once: true }
                    );

                    picker.addEventListener(
                        "duetBlur",
                        function (e) {
                            console.log("duet Blur input", e);

                            // searchBarFactory.deactivateDropdown(
                            //     $scope.oSearchCalender
                            // ); // Only used to handle other dropdowns
                        },
                        { once: true }
                    );

                    // function which disables past dates but includes today

                    function dateDisableFn(date) {
                        return moment(date).add("days", 1) < today; // only today and future dates
                    }

                    picker.isDateDisabled = dateDisableFn;

                    // regex for danish dates
                    const DATE_FORMAT = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;

                    picker.dateAdapter = {
                        parse(value = "", createDate) {
                            const matches = value.match(DATE_FORMAT);

                            if (matches) {
                                return createDate(
                                    matches[3],
                                    matches[2],
                                    matches[1]
                                );
                            }
                        },
                        format(date) {
                            return (
                                `${date.getDate()}-` +
                                `${date.getMonth() + 1}-` +
                                `${date.getFullYear()}`
                            );
                        },
                    };

                    picker.show();
                });
            };

            const duetClose = () => {
                // console.log("duet close calender", e);
                $scope.$apply(() => {
                    searchBarFactory.deactivateAllDropdowns(); // Only used to handle other dropdowns
                });
            };

            /**
             * note: No Scope defined -> aka same as parent
             */

            // $scope.$on(
            //     "update-date-broadcast",
            //     function ($event, obj) {
            //         $timeout(() => {
            //             console.log(
            //                 "update-date-broadcast - SearchBarCalender"
            //             );
            //         });
            //     },
            //     1500
            // );

            const setPickerValue = (date_DD_MM_YYYY) => {
                const picker = document.querySelector("duet-date-picker");

                picker.value = moment(date_DD_MM_YYYY, "DD-MM-YYYY").format(
                    "YYYY-MM-DD"
                );
            };
        },
    };
}
